export const environment = {
  production: true,
  apiBaseUrl: '' as string,
  googleClientId: '370513580190-dknijddjqqk3rcjqovpuqemp8e8q7t6a.apps.googleusercontent.com',
  googleSignInEnabled: true,
};
